import { useLocalStorage } from "@src/appV2/lib/utils/useLocalstorage";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

const HAS_SEEN_PLACEMENT_FILTER_TOOLTIP_KEY = "has-seen-placement-filter-tooltip";

export function useHasSeenPlacementFilterTooltip() {
  const worker = useDefinedWorker();

  const [hasSeenPlacementFilterTooltip, setHasSeenPlacementFilterTooltipValue] = useLocalStorage(
    `${HAS_SEEN_PLACEMENT_FILTER_TOOLTIP_KEY}-${worker.userId}`,
    false
  );

  const setHasSeenPlacementFilterTooltip = () => {
    setHasSeenPlacementFilterTooltipValue(true);
  };

  return {
    hasSeenPlacementFilterTooltip,
    setHasSeenPlacementFilterTooltip,
  };
}
